<template>
    <div class="artiwrap">
        <iframe :class="['subframe',{'subfull':isfull}]" scrolling="no" frameborder="0" src="/arti/arti.html" ref="subframe"></iframe>
        <div class="subfullmask" v-if="isfull" @click="unfull"></div>
        <div class="subclose" v-if="isfull"><a href="#" @click="unfull"><i class="el-icon-close"></i></a></div>
    </div>

</template>

<script>

    export default {
        name: 'Carti',
        data() {
            return {
                jsonuser: {},
                learnid: 0,
                jsonlearn: {}
            };
        },
        props: {
            info: {
                type: Object,
                default: () => { }
            },
            isfull: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            getlesson: function (isagree = false) {
                let jsondata = { 'postdata': { 'act': 'tc_learn_te', 'id': this.info.id, 'data': { 'isagree': isagree ? 1 : 0 } } };
                this.$common.post(jsondata, (res) => {

                    if ((this.info.isquiz == 1) && !isagree && this.$store.getters.isstu) {
                        let cqs = res.qs + 1;

                        var msg = "你有3次测验的机会，这是第" + cqs + "次机会，确认要进行测验吗？";
                        this.$common.confirm(msg, () => {
                            this.getlesson(true);
                        });
                    }
                    else {
                        this.learnid = res.infodata.id;
                        this.jsonuser.stuname = this.$store.state.showname;
                        this.jsonuser.stuuser = res.infodata.username;
                        this.jsonuser.suspend = res.infodata.suspend;
                        this.showarti();
                    }
                });
            },
            showarti: function () {
                this.jsonlearn = {};
                let artiurl = '/arti/' + this.info.url + '/index_lms_html5.html';
                this.$nextTick(() => {
                    this.$emit('articomplete', 0);
                    //this.$refs.subframe.contentWindow.setdata(artiurl, this.jsonuser);
                    let iframe = this.$refs.subframe;
                    if (iframe.contentWindow.setdata == undefined) {
                        if (iframe.attachEvent) {
                            iframe.attachEvent("onload", () => {
                                iframe.contentWindow.setdata(artiurl, this.jsonuser);
                            });
                        } else {
                            iframe.onload = () => {
                                iframe.contentWindow.setdata(artiurl, this.jsonuser);
                            };
                        }

                    }
                    else {
                        iframe.contentWindow.setdata(artiurl, this.jsonuser);
                    }
                })

            },
            savedata: function () {
                let jsondata = { 'postdata': { 'act': 'tc_learn_tesave', 'id': this.learnid, 'data': this.$common.basic.isobjexist(this.jsonlearn) ? this.jsonlearn : '' }, 'msg': '' };
                this.$common.post(jsondata, () => {
                    this.$emit('articomplete', this.jsonlearn.iscompleted);
                });

            },
            unfull: function () {
                this.$emit('update:isfull', false);
            },
            framemessage: function (e) {
                this.jsonlearn = e.data;
                this.savedata();
            }
        },
        beforeDestroy() {
            this.savedata();
            window.removeEventListener('beforeunload', this.savedata);
            window.removeEventListener('message', this.framemessage);
        },
        mounted() {
            this.getlesson();
            window.addEventListener('message', this.framemessage)
            window.addEventListener('beforeunload', this.savedata);
        }
    }
</script>
